import React from 'react';
import { useAuth } from '../context/AuthContext';
import {
  DashboardDeadlinePortfolioGrid,
  DashboardErrorState,
  DashboardHeader,
  DashboardLoadingState,
  DashboardRecentContracts,
  DashboardStatsGrid,
  DashboardTeamActivity,
  DashboardTopDeadlineAlert,
} from '../features/dashboard/DashboardSections';
import useDashboardData from '../features/dashboard/useDashboardData';

// The legal/compliance-ops dashboard: portfolio stats, deadlines, review queue,
// and team activity. Shown to legal/admin (canWriteContracts). Regular users get
// UserDashboard instead — Dashboard.js routes by role.
export default function OpsDashboard() {
  const { user, canWriteContracts } = useAuth();
  const {
    activeCount,
    deadlines30,
    dismissReminder,
    dismissingId,
    draftCount,
    error,
    expiring30,
    expiringSoon,
    inReviewCount,
    loading,
    noticeSoon,
    noticeUpcoming30,
    recent,
    recentActivity,
    reviewQueue,
    topDeadline,
    totalContracts,
    tprmPipeline,
    typeHeat,
  } = useDashboardData({ canWriteContracts });

  if (loading) return <DashboardLoadingState />;
  if (error) return <DashboardErrorState error={error} />;

  const firstName = (user?.name || '').split(' ')[0] || user?.email?.split('@')[0] || 'there';
  const todayLabel = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });

  return (
    <div className="canvas-inner animate-fade-in">
      <DashboardHeader
        canWriteContracts={canWriteContracts}
        deadlines30={deadlines30}
        expiring30={expiring30}
        firstName={firstName}
        noticeUpcoming30={noticeUpcoming30}
        todayLabel={todayLabel}
      />

      <DashboardTopDeadlineAlert
        canWriteContracts={canWriteContracts}
        dismissingId={dismissingId}
        dismissReminder={dismissReminder}
        topDeadline={topDeadline}
      />

      <DashboardStatsGrid
        activeCount={activeCount}
        deadlines30={deadlines30}
        draftCount={draftCount}
        expiring30={expiring30}
        inReviewCount={inReviewCount}
        noticeUpcoming30={noticeUpcoming30}
        reviewQueue={reviewQueue}
        totalContracts={totalContracts}
        tprmPipeline={tprmPipeline}
      />

      <DashboardDeadlinePortfolioGrid
        expiringSoon={expiringSoon}
        noticeSoon={noticeSoon}
        typeHeat={typeHeat}
      />

      <DashboardTeamActivity
        canWriteContracts={canWriteContracts}
        recentActivity={recentActivity}
      />

      <DashboardRecentContracts
        canWriteContracts={canWriteContracts}
        recent={recent}
      />
    </div>
  );
}
